import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgxUiLoaderService } from "ngx-ui-loader";
import { apiRoutesParent, apiRoutesStudent } from '../constants/constants';
import { OrigenService } from '../services/origen.service';
import { NotificationService } from './notification.service';

@Injectable({ providedIn: 'root' })
export class AvisoService
{
    private apiRoutes: any = {};
    constructor(private http: HttpClient, private notificationService: NotificationService, private origenService: OrigenService, private loaderService: NgxUiLoaderService) 
    {
        const origen = this.origenService.getOrigin();
        this.apiRoutes = origen.padre ? apiRoutesParent : apiRoutesStudent;
    }

    getAvisos(Params :any)
    {
        this.loaderService.start();
        return new Promise((resolve, reject) => {
            this.http.get(this.apiRoutes.ROUTE_AVISO,{ params: Params }).subscribe(
            (response: any) => {
                this.notificationService.verifyStatus(response, false);
                this.loaderService.stop();
                resolve(response);
            },
            (error: any) => {
                this.notificationService.error(error);
                this.loaderService.stop();
                reject();
            });
        });
    }

}